import React from 'react';

export const AllinclusiveIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 2 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width={width} height={height} rx="12" fill="white" />
        <path
          d="M0.986 18L5.424 8.2H6.81L11.262 18H9.792L5.83 8.984H6.39L2.428 18H0.986ZM2.876 15.55L3.254 14.43H8.77L9.176 15.55H2.876ZM13.1439 18V8.2H14.5439V18H13.1439Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
